import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { routeName } from '~/@common/constants'
import { nativeEventBus } from '~/@common/services/nativeEventBus'
import { homeApi } from '~/@pages/home/@common/api'

/**
 * PUSH 알림 기능을 위해
 * FCM 디바이스 등록을 처리하는 hook.
 * 네이티브에서 발생하는 'registerDevice' 이벤트를 수신하여
 * 서버에 FCM 토큰을 등록한다.
 */
export const useFcmDeviceRegistration = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === routeName.login) return

    const unsub = nativeEventBus.subscribe('registerDevice', (e) => {
      const { token, deviceId, platformType } = e.detail
      homeApi.postFcmNotificationToken({
        token,
        deviceId,
        platformType,
      })
      localStorage.setItem('deviceId', deviceId)
    })

    return unsub
  }, [location.pathname])
}
